import { Injectable } from '@angular/core';
import { PresentationModel } from 'app/views/presentations/models/presentation.model';
import { WidgetComponent } from 'app/views/presentations/widgets/widget.component';

export abstract class PresentationHandler {

    /** The priority for the handler: lower number mean higher priority to process this handler */
    public priority: number = 0;
    public onSave(presentation: PresentationModel) {}
    public onDelete(presentation: PresentationModel) {}
}



// WEBPACK FOOTER //
// ./src/app/services/presentation/presentationHandler.ts